import { render, staticRenderFns } from "./Info_Testimonial.vue?vue&type=template&id=63282334&scoped=true&"
import script from "./Info_Testimonial.vue?vue&type=script&lang=js&"
export * from "./Info_Testimonial.vue?vue&type=script&lang=js&"
import style0 from "./Info_Testimonial.vue?vue&type=style&index=0&id=63282334&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63282334",
  null
  
)

export default component.exports